import Contact from './Contact-redux';

export default Contact;
